<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
export default {
  page: {
    title: 'Forget Password',
    meta: [{ name: 'description', content: `Forget Password to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      email: '',
      error: [],
      tryingToReset: false,
      isResetError: false,
      isSuccess: false,
      successMessage: null
    }
  },
  computed: {
  },
  methods: {
    ...authMethods,
    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToReset() {
      this.tryingToReset = true
      // Reset the authError if it existed.
      this.error = []
      return this.resetPassword({
        email: this.email
      })
        .then((data) => {
          this.tryingToReset = false
          this.isResetError = false
          this.isSuccess = true
          this.successMessage = data.data.message
        })
        .catch((error) => {
          this.tryingToReset = false
          this.error = {"message":["The given data was invalid."]};
          if(error.response && error.response.data && error.response.data.errors) {
            this.error = error.response.data.errors;
          }
          this.isResetError = true
          this.isSuccess = false
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <a href="/">
                <span><img src="@assets/images/logo-sm-dark.png" alt="" height="21"/> </span>
                <h3 class="d-inline align-top ml-1 text-uppercase">{{app_name}}</h3>
              </a>
              <p class="text-muted mb-4 mt-3"
                >Enter your email address and we'll send you an email with instructions to reset your password.</p
              >
            </div>

            <div v-if="error" v-for="(item, index) in error" :key="index">
              <b-alert v-model="isResetError" v-for="(item2, index2) in item" :key="index2" variant="danger" dismissible>
                {{item2}}
              </b-alert>
            </div>

            <b-alert v-model="isSuccess" variant="success" dismissible>
              {{successMessage}}
            </b-alert>


            <b-form @submit.prevent="tryToReset">
              <b-form-group
                id="email-group"
                label="Email"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="email"
                  type="email"
                  required
                  placeholder="Enter email"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block"
                  > Reset Password </b-button
                >
              </b-form-group>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="row mt-3">
          <div class="col-12 text-center">
            <p class="text-muted"
              >Already have account?
              <router-link tag="a" to="/login" class="text-primary font-weight-medium ml-1">Log In</router-link>
              </p
            >
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
